import { AbyssTheme as themeConfiguration } from '@src/app/browser';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { isEmpty } from 'lodash';
import React from 'react';

/**
 * Tooltip: Sources
 *
 * @TODO - Needs description.
 *
 * @param codeDetails
 * @returns {Element}
 * @constructor
 */
export function RiskCodes({ codeDetails = [] }) {
  return (
    <Layout.Stack alignItems="left" alignLayout="left" grow space={Number(themeConfiguration?.theme?.space?.xs) || 4}>
      {!isEmpty(codeDetails) &&
        codeDetails.map((code) => {
          return (
            <div
              key={code.codeId}
              style={{
                padding: 'var(--abyss-space-sm)',
              }}
            >
              {String(code?.codeId).length === 1 ? `0${code?.codeId}` : code.codeId} - {code?.codeDesc}
            </div>
          );
        })}
    </Layout.Stack>
  );
}
